<template>
    <div class="part-id-generation">
        <div class="flex setting-header">
        <div class="setting-heading-box">
        <img class="btn-icon setting-icon" src="~@/assets/images/icons/tenant-feature-configuration.svg" alt="" width="15px" />
      <h3 class="setting-name">
        Tenant Feature Configration
      </h3>
        <p class="setting-subscript">Enablement and customization of tenant-specific features</p>
      </div>
    </div>
    <div class="component-cards">
      <div class="tab-headers">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        class="s"
        :class="['tab-header', { active: selectedTab.name === tab.name }]"
        @click="selectedTab = tab"
      >
        {{ tab.name }}
      </div>
    </div>
      <div v-if="isInitialLoading" class="loading-container">
        <loading-circle />
      </div>
      <template v-else-if="selectedTab.name === 'MATERIAL'">
      <configuration-panel
        :rules="materialRules"
        :tab-label="selectedTabLabel"
        :selectedTab="selectedTab"
        :validation-state="ruleValidationMap"
        :tabs="configurationTabs"
        :lists="dropdownLists"
        :editing-rule-id="editingRuleId"
        :can-manage-rules="isTenantAdmin"
        :circular-dependencies="circularDependencyResult"
        @add-rule="addRule"
        @start-edit-rule="startRuleEdit"
        @save-edit-rule="handleEditSave"
        @cancel-edit-rule="cancelRuleEdit"
        @update-rule="updateRule"
        @remove-rule="handleRuleDelete"
      />
      <!-- <div class="material-rules-actions">
        <button class="btn mr-3" :disabled="disable || isSavingRules" @click="saveRules">Save Rules</button>
        </div> -->
    </template>
    <div v-else class="sequence--container">
      <div v-if="selectedTab.name !== 'FACTORIES'" class="component-card">
       <div class="component-row">
            <div class="col s">{{ selectedTab.name }} FORM TEMPLATE</div>            <div class="col s">
             <label>{{ selectedTab.name === 'MATERIAL' ? 'Standard Material Form - SMF' : 'Standard Bom From - SBF' }}</label>
            </div>
           </div>
          </div>
          <div v-for="active in activeSequences" :key="active.type" class="component-card">
        <div class="component-row">
    <div class="col s">
      SEQUENCE GENERATOR {{ active.type }}
    </div>
    <div class="col s">
      <div class="pointer">
        <custom-dropdown  :list="getDropdownList(active.id)"
         :searchText="searchKeyword"
         :disabled="!isTenantAdmin"
        :selected="sequenceValues[active.type]"
 @select="value => handleSelection(active.type, value)"
>
        <div slot="before-items" class="p-2 input-group xs">
            <input v-model="searchKeyword" placeholder="Search..." type="text" />
            </div>
          </custom-dropdown>
      </div>
      </div>
      </div>
        </div>
        <div v-if="isTenantAdmin" class="pt-9 flex-end">
        <button class="btn mr-3" :disabled="disable" @click="save">Save</button>
        </div>
    </div>
    </div>
  </div>
</template>
<script>
import { AddressLocation, getDetailFormTemplate, getGivenCustomListsData, GetAllSequenceTemplates, GetMaterialCustomList, GetTemplateData, MaterialGroup, UnitOfMaterial } from '@/api'
import { updateTenantCofig, GetTenantConfigTypes } from '@/api/apis/tenantConfigFeature'
import { alert as notifyAlert, success } from '@/plugins/notification'
import { mapGetters, mapMutations } from 'vuex'
import loadingCircle from '@/components/common/loadingCircle.vue'
import CustomDropdown from '@/components/common/customDropdown.vue'
import ConfigurationPanel from './ConfigItems/ConfigurationPanel.vue'
import MaterialIcon from '@/components/common/icons/materialIcon.vue'
import { CONFIGURE_TYPES, INPUT_TYPES, OPERATORS, SOURCE_ITEMS } from './ConfigItems/configConstants'
import { createAction, createId, createRule } from './ConfigItems/configModel'
import { detectCircularDependencies, findConditionField, findOptionByValue, formatDependencyFieldKey, formatTemplateFieldIds, formatToDropDownInput, getActionTypes, getActionValueItems, getConditionStoredValue, getCustomListLookupKey, getMapSourceKey, hasConditionRows, isIncludesOperator, isSequenceTemplateConfig, normalizeStringListValue, optionDisplayLabel, optionValue, resolveActionOption, toIntegerId, usesNativeIntegerIds, validateConfigurationRules } from './ConfigItems/conditionHelper.js'
import { createConfigurationRuleApi, deleteConfigurationRuleApi, getRulesApi, getStandardMaterialFormFieldsApi } from '@/api/apis/configuration.js'
import Loader from '@/plugins/loader/index.js'
import config from '@/config'

const optionList = values => values.map(value => ({ id: value, name: value }))

const materialTabMeta = {
  key: 'MATERIAL',
  label: 'MATERIAL',
  iconComponent: MaterialIcon,
  color: '#246BFE',
  softColor: '#EEF4FF'
}

export default {
  components: { ConfigurationPanel, CustomDropdown, loadingCircle },
  name: 'config-feature',
  data () {
    return {
      selectedTab: { id: 1, name: 'MATERIAL' },
      configurationTabs: [materialTabMeta],
      searchKeyword: '',
      jump: null,
      loading: true,
      disable: false,
      perPage: null,
      tabs: [
        {
          id: 1,
          name: 'MATERIAL'
        },
        {
          id: 2,
          name: 'BOM'
        },
        {
          id: 12,
          name: 'FACTORIES'
        }
      ],
      featureConfigMap: {
        MATERIAL: {
          sequences: [{ type: 'MATERIAL', id: 1 },
            { type: 'PRODUCT_CODE', id: 6 }]
        },
        BOM: {
          sequences: []
        },
        FACTORIES: {
          sequences: [{ type: 'RESOURCES', id: 12 },
            { type: 'STORAGE_BINS', id: 12 }]
        }
      },
      sequenceValues: {},
      allSequenceOptions: [],
      rulesLoading: true,
      isInitializing: true,
      setupRequestId: 0,
      dropdownLists: {
        sourceFieldTypes: SOURCE_ITEMS,
        configurationTypes: CONFIGURE_TYPES,
        conditionFields: [],
        conditionOperators: optionList(['equals', 'contains', 'starts with', 'is empty']),
        conditionValues: optionList([
          'RAW',
          'FINISH',
          'Flange',
          'Flange Modified',
          'Yes',
          'Released'
        ]),
        actionTypes: optionList(['Trigger Plugin', 'Assign Workflow', 'Set Visibility']),
        sequenceTemplateValues: []
      },
      rules: [],
      deletedRuleIds: [],
      editingRuleId: null,
      editingRuleSnapshot: null,
      isSavingRules: false,
      existingRuleIds: [],
      ruleValidationMap: {},
      showValidationErrors: false,
      circularDependencyResult: { hasCycle: false, cycleRuleIds: [], conflictingFields: [], cycleEdges: [] }
    }
  },
  watch: {
    selectedTab: {
      immediate: true,
      async handler () {
        try {
          await this.initializeSelectedTab()
        } catch (err) {
          console.log(err)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById', 'isOnProjectLevel', 'tenantDefaultsData']),
    materialRules () {
      return this.rules.filter(rule => rule.feature === this.selectedTab.name)
    },
    selectedTabLabel () {
      return this.selectedTab.name
    },
    activeSequences () {
      return this.featureConfigMap[this.selectedTab.name]?.sequences || []
    },
    isInitialLoading () {
      return this.isInitializing || this.loading || this.rulesLoading
    },
    isTenantAdmin () {
      return (
        this.user.tenantLevelRole === 'ADMIN'
      )
    }
  },
  methods: {
    ...mapMutations('tenantConfig', ['addToCustomListMap', 'appendToCustomListMap', 'setSmfList']),
    async initializeSelectedTab () {
      const requestId = ++this.setupRequestId
      this.isInitializing = true
      this.loading = true
      this.rulesLoading = true

      try {
        await this.getSequenceList()
        if (requestId !== this.setupRequestId) return
        await this.setup()
      } finally {
        if (requestId === this.setupRequestId) {
          this.isInitializing = false
        }
      }
    },
    addRule () {
      if (this.editingRuleId) {
        return
      }
      const nextRule = {
        ...createRule(this.selectedTab.name),
        isDraft: true,
        isEditing: true
      }
      this.rules.push(nextRule)
      this.editingRuleId = nextRule.id
      this.editingRuleSnapshot = null
      this.setRuleEditingState(nextRule.id)
      this.clearRuleValidation(nextRule.id)
      this.checkCircularDependencies()
    },
    updateRule (updatedRule) {
      const index = this.rules.findIndex(rule => rule.id === updatedRule.id)
      if (index >= 0) this.$set(this.rules, index, updatedRule)
      this.refreshRuleValidationState(updatedRule.id, updatedRule)
      this.refreshDuplicateConditionValidationStates(updatedRule.id)
      this.checkCircularDependencies()
    },
    refreshDuplicateConditionValidationStates (skipRuleId = null) {
      Object.keys(this.ruleValidationMap).forEach((ruleId) => {
        if (this.matchRuleId(ruleId, skipRuleId)) {
          return
        }
        if (!this.ruleValidationMap[ruleId]?.duplicateConditions) {
          return
        }
        const rule = this.materialRules.find(item => this.matchRuleId(item.id, ruleId))
        if (!rule) {
          return
        }
        const validation = this.validateRule(rule)
        if (validation.isValid) {
          this.clearRuleValidation(ruleId)
          return
        }
        // These rules are not the one being edited, so keep whatever message
        // visibility they already had instead of blanking it.
        const wasShowingMessage = Boolean(this.ruleValidationMap[ruleId]?.message)
        this.$set(this.ruleValidationMap, ruleId, {
          ...validation.validationState,
          message: wasShowingMessage ? validation.validationState.message : ''
        })
      })
    },
    matchRuleId (leftId, rightId) {
      return String(leftId) === String(rightId)
    },
    setRuleEditingState (ruleId = null) {
      this.rules = this.rules.map(rule => ({
        ...rule,
        isEditing: ruleId !== null && this.matchRuleId(rule.id, ruleId)
      }))
    },
    startRuleEdit (ruleId) {
      if (this.editingRuleId && !this.matchRuleId(this.editingRuleId, ruleId)) {
        return
      }
      const rule = this.rules.find(item => this.matchRuleId(item.id, ruleId))
      if (!rule) {
        return
      }
      this.clearRuleValidation(ruleId)
      this.editingRuleId = ruleId
      this.editingRuleSnapshot = JSON.parse(JSON.stringify(rule))
      this.rules = this.rules.map(item => ({
        ...item,
        isEditing: this.matchRuleId(item.id, ruleId),
        expanded: this.matchRuleId(item.id, ruleId)
      }))
    },
    cancelRuleEdit (ruleId) {
      const rule = this.rules.find(item => this.matchRuleId(item.id, ruleId))
      if (!rule) {
        return
      }
      this.clearRuleValidation(ruleId)
      if (rule.isDraft) {
        this.removeRule(ruleId)
      } else if (this.editingRuleSnapshot?.id === ruleId) {
        this.updateRule(JSON.parse(JSON.stringify(this.editingRuleSnapshot)))
      }
      this.editingRuleId = null
      this.editingRuleSnapshot = null
      this.setRuleEditingState()
      this.syncRuleValidation()
    },
    removeRule (ruleId) {
      this.rules = this.rules.filter((rule) => {
        if (rule.id !== ruleId) {
          return rule
        }
        if (rule?.flag === 'existing' && !this.deletedRuleIds.includes(rule.id)) {
          this.deletedRuleIds.push(rule.id)
        }
      })
      if (this.matchRuleId(this.editingRuleId, ruleId)) {
        this.editingRuleId = null
        this.editingRuleSnapshot = null
        this.setRuleEditingState()
      }
      this.clearRuleValidation(ruleId)
    },
    syncRuleValidation (force = false) {
      if (!this.showValidationErrors && !force) {
        return true
      }
      const { isValid, ruleValidationMap } = validateConfigurationRules(this.materialRules)
      const nextValidationMap = {}
      let hasRuleValidationError = false
      Object.keys(ruleValidationMap).forEach((ruleId) => {
        const rule = this.materialRules.find(item => this.matchRuleId(item.id, ruleId))
        const nameRequired = !this.hasValidRuleName(rule)
        const duplicateName = !nameRequired && !this.isRuleNameUnique(rule)
        const duplicateConditionRule = rule ? this.findRuleWithIdenticalConditions(rule) : null
        if (nameRequired) {
          hasRuleValidationError = true
        }
        if (duplicateName || duplicateConditionRule) {
          hasRuleValidationError = true
        }
        const validationState = {
          ...ruleValidationMap[ruleId],
          nameRequired,
          duplicateName,
          duplicateConditions: Boolean(duplicateConditionRule),
          duplicateConditionRuleName: duplicateConditionRule?.name || ''
        }
        nextValidationMap[ruleId] = {
          ...validationState,
          message: this.getRuleValidationMessage(validationState)
        }
      })
      this.materialRules.forEach((rule) => {
        if (Object.prototype.hasOwnProperty.call(nextValidationMap, rule.id)) {
          return
        }
        const nameRequired = !this.hasValidRuleName(rule)
        const duplicateName = !nameRequired && !this.isRuleNameUnique(rule)
        const duplicateConditionRule = this.findRuleWithIdenticalConditions(rule)
        if (nameRequired || duplicateName || duplicateConditionRule) {
          hasRuleValidationError = true
          nextValidationMap[rule.id] = {
            nameRequired,
            duplicateName,
            duplicateConditions: Boolean(duplicateConditionRule),
            duplicateConditionRuleName: duplicateConditionRule?.name || '',
            message: this.getRuleValidationMessage({
              nameRequired,
              duplicateName,
              duplicateConditions: Boolean(duplicateConditionRule),
              duplicateConditionRuleName: duplicateConditionRule?.name || ''
            })
          }
        }
      })
      this.ruleValidationMap = nextValidationMap
      return isValid && !hasRuleValidationError
    },
    checkCircularDependencies () {
      this.circularDependencyResult = detectCircularDependencies(this.materialRules)
      return !this.circularDependencyResult.hasCycle
    },
    async getSequenceTemplateValues () {
      try {
        const materialRes = await GetAllSequenceTemplates(config.CORE_FEATURES.MATERIAL)
        const templates = materialRes?.core_sequence_id_template || []
        this.dropdownLists.sequenceTemplateValues = templates.map((template) => ({
          id: template.id,
          name: template.name
        }))
      } catch (err) {
        this.dropdownLists.sequenceTemplateValues = []
        console.log(err)
      }
    },
    async getSequenceList () {
      this.loading = true
      try {
        const res = await GetTemplateData(this.jump, this.perPage, this.searchKeyword, this.selectedTab.name, true)
        this.allSequenceOptions = res.core_sequence_id_template || []
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    getDropdownList (featureId) {
      return this.allSequenceOptions.filter(
        (item) => item.core_feature?.id === featureId
      )
    },
    handleSelection (type, value) {
      this.$set(this.sequenceValues, type, value)
    },
    async setup () {
      this.rulesLoading = true
      try {
        const tenantConfig = await GetTenantConfigTypes()
        const tenantDefaults = tenantConfig.tenant_defaults?.[0]
        this.$store.commit('setTenentDefaults', tenantDefaults)
        const config = tenantConfig.tenant_defaults[0]?.tenant_feature_configuration
        const featureKey = this.selectedTab.name
        if (config) {
          for (const active of this.activeSequences) {
            let savedId = null
            if (featureKey === 'FACTORIES') {
              savedId = config[featureKey]?.[active.type]?.SEQUENCE_TEMPLATE_DEFAULT
            } else {
              savedId = config[active.type]?.SEQUENCE_TEMPLATE_DEFAULT
            }
            if (savedId) {
              const filteredList = this.getDropdownList(active.id)
              const matchedItem = filteredList.find(
                item => item.id === savedId
              )
              if (matchedItem) {
                this.$set(this.sequenceValues, active.type, matchedItem)
              }
            }
          }
        }
        await this.materialConfigSetup() // initiating material setup
        await this.loadRulesData()
      } catch (err) {
        console.log(err)
      } finally {
        this.rulesLoading = false
      }
    },
    async save () {
      this.disable = true
      try {
        const res = await updateTenantCofig(this.selectedTab.name, this.sequenceValues)
        success(res.message)
      } catch (err) {
        console.log(err)
      } finally {
        this.disable = false
      }
    },
    async allMaterialRelatedDropdowns () {
      try {
        if (this.selectedTab.name === 'MATERIAL') {
          const [uom, matg, addloc, materialType] = await Promise.allSettled([UnitOfMaterial(), MaterialGroup(), AddressLocation(), GetMaterialCustomList()])
          if (uom.status === 'fulfilled') {
            this.addToCustomListMap({ data: uom.value.custom_list_values.map(item => ({ name: item.name, id: item.id })), id: 'unit_of_material' })
          }
          if (matg.status === 'fulfilled') {
            this.addToCustomListMap({ data: matg.value.custom_list_values.map(item => ({ name: item.name, id: item.id })), id: 'material_group' })
          }
          if (addloc.status === 'fulfilled') {
            this.addToCustomListMap({ data: addloc.value.address_locations.map(item => ({ name: item.name, id: item.id })), id: 'storage_loc' })
          }
          if (materialType.status === 'fulfilled') {
            this.addToCustomListMap({ data: materialType.value.custom_list_values.map(item => ({ name: item.name, id: item.id })), id: 'material_type' })
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getGivenCustomList (ids) {
      try {
        const customListData = await getGivenCustomListsData(ids)
        const customListMap = {}
        for (const customList of customListData.core_custom_list) {
          customListMap[customList.id] = customList.custom_list_values
        }
        this.appendToCustomListMap(customListMap)
      } catch (err) {
        console.log(err)
      }
    },
    async handleSMFTemplate () {
      try {
        const templateId = this.tenantDefaultsData?.material_temp_id
        const res = await getDetailFormTemplate(templateId)
        const activeTemplateVersion = (res.core_form_templates_by_pk?.template_versions || [])
          .find(version => version.active === true)
        const formTemplateData = activeTemplateVersion || null
        const { configIdSet, smfList } = formatTemplateFieldIds(formTemplateData)
        this.setSmfList(smfList)
        if (configIdSet.size > 0) {
          await this.getGivenCustomList([...configIdSet])
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    async materialConfigSetup () {
      try {
        if (this.selectedTab.name !== 'MATERIAL') {
          return
        }
        await this.getSequenceTemplateValues()
        await this.allMaterialRelatedDropdowns()
        await this.handleSMFTemplate()
      } catch (err) {
        console.log(err)
      }
    },
    async validateStandardMaterialFormFieldsBeforeSave () {
      const templateId = this.tenantDefaultsData?.material_temp_id
      if (!templateId) {
        return true
      }

      const templateResponse = await getDetailFormTemplate(templateId)
      const activeTemplateVersion = (templateResponse?.core_form_templates_by_pk?.template_versions || [])
        .find(version => version.active === true)
      const templateVersionId = activeTemplateVersion?.id
      const fieldIds = (activeTemplateVersion?.template_fields || [])
        .map(field => field?.field_id)
        .filter(Boolean)
      const inputFieldCount = fieldIds.length

      if (!templateVersionId || inputFieldCount === 0) {
        return true
      }

      const validationResponse = await getStandardMaterialFormFieldsApi({ fieldIds, templateVersionId })
      const savedFieldCount = validationResponse?.template_fields_aggregate?.aggregate?.count ??
        validationResponse?.data?.template_fields_aggregate?.aggregate?.count

      if (inputFieldCount !== savedFieldCount) {
        window.alert('Field Ids do not exist , Please Refresh.')
        return false
      }

      return true
    },
    fallbackOption (value) {
      if (value === undefined || value === null || value === '') {
        return ''
      }

      if (typeof value === 'object') {
        return value
      }

      return {
        id: value,
        name: optionDisplayLabel(value)
      }
    },
    resolveActionTargetField (selectedConfig, fieldValue) {
      const options = getActionTypes(selectedConfig)
      return resolveActionOption(options, fieldValue) || this.fallbackOption(fieldValue)
    },
    getFieldCustomListId (field) {
      return field?.customListId ?? field?.custom_list_id ?? null
    },
    filterSourceOptionsForTargetField (sourceOptions, targetField) {
      if (!Array.isArray(sourceOptions)) {
        return []
      }

      const targetType = targetField?.type
      const targetCustomListId = this.getFieldCustomListId(targetField)
      if (targetType !== INPUT_TYPES.CUSTOM_LIST || !targetCustomListId) {
        return sourceOptions
      }

      return sourceOptions.filter((item) => {
        return item?.type === INPUT_TYPES.CUSTOM_LIST &&
          `${this.getFieldCustomListId(item)}` === `${targetCustomListId}`
      })
    },
    resolveMapSourceField (sourceType, sourceKey, targetField = null) {
      if (!sourceType || sourceKey === undefined || sourceKey === null || sourceKey === '') {
        return ''
      }

      const rawSourceOptions = optionValue(sourceType) === 'PLUGIN_FIXED_FIELDS'
        ? [{
          id: sourceKey,
          name: sourceKey
        }]
        : getActionValueItems({
          selectedConfig: sourceType,
          lists: this.dropdownLists
        })
      const sourceOptions = this.filterSourceOptionsForTargetField(rawSourceOptions, targetField)

      return resolveActionOption(sourceOptions, sourceKey) || this.fallbackOption(sourceKey)
    },
    conditionValuePayload (conditionItem) {
      const payload = {
        int_list: null,
        int_value: null,
        string_value: null,
        bool_value: null,
        date_value: null,
        string_list: null
      }
      const value = optionValue(conditionItem.value)

      if (isIncludesOperator(conditionItem.operator)) {
        if (conditionItem.field?.type === INPUT_TYPES.CUSTOM_LIST) {
          const integerList = (Array.isArray(conditionItem.value) ? conditionItem.value : [])
            .map(item => toIntegerId(optionValue(item)))
            .filter(item => item !== null)
          payload.int_list = integerList.length ? integerList : null
        } else {
          payload.string_list = normalizeStringListValue(conditionItem.value)
        }
        return payload
      }

      switch (conditionItem.field?.type) {
      case INPUT_TYPES.CUSTOM_LIST:
      {
        const integerValue = usesNativeIntegerIds(conditionItem.field) ? toIntegerId(value) : null
        if (integerValue !== null) {
          payload.int_value = integerValue
        } else {
          payload.string_value = value === undefined || value === null ? null : String(value)
        }
        break
      }
      case INPUT_TYPES.BOOLEAN:
        payload.bool_value = value
        break
      case INPUT_TYPES.DATE:
        payload.date_value = value
        break
      case INPUT_TYPES.NUMBER:
      case INPUT_TYPES.TEXT:
      case INPUT_TYPES.LONG_TEXT:
      case INPUT_TYPES.TIME:
      default:
        payload.string_value = String(value)
        break
      }

      return payload
    },
    buildRuleInput (rule) {
      const hasConditions = hasConditionRows(rule)
      const ruleObj = {
        name: (rule.name || '').trim(),
        description: '',
        feature_id: '1',
        target: rule.configuration?.id,
        type: 'EXECUTION',
        validation_groups: { data: [] },
        trigger_actions: { data: [] }
      }

      if (hasConditions) {
        const seenValidationGroups = new Set()
        for (const [index, groupItem] of rule.conditionGroups.entries()) {
          const gruopObj = {
            sequence: index,
            type: groupItem.match,
            operator_to_next_group: groupItem.joinWithNext,
            validation_conditions: { data: [] }
          }
          for (const conditionItem of groupItem.conditions) {
            const isPluginCustomField = optionValue(conditionItem.fieldType) === 'PLUGIN_CUSTOM_FIELDS'
            const conditionObj = {
              left_operand: isPluginCustomField ? optionValue(conditionItem.field) : conditionItem.field?.id,
              operator: conditionItem.operator?.id,
              ...this.conditionValuePayload(conditionItem),
              source: conditionItem.fieldType?.id
            }
            gruopObj.validation_conditions.data.push(conditionObj)
          }
          const groupSignature = JSON.stringify({
            type: gruopObj.type,
            operator_to_next_group: gruopObj.operator_to_next_group,
            validation_conditions: gruopObj.validation_conditions.data
          })
          if (seenValidationGroups.has(groupSignature)) {
            continue
          }
          seenValidationGroups.add(groupSignature)
          ruleObj.validation_groups.data.push(gruopObj)
        }
      }

      for (const action of rule.actions) {
        const isSequenceTemplate = isSequenceTemplateConfig(rule.configuration)
        const actionType = optionValue(action.type) || 'SET'
        const actionObj = {
          trigger_action: actionType === 'SET' ? 'UPDATE' : actionType,
          metadata: isSequenceTemplate
            ? (action.metadata || null)
            : actionType === 'MAP'
              ? [{
                source: optionValue(action.source),
                target_key: optionValue(action.field),
                source_key: getMapSourceKey(action)
              }]
              : {
                field: optionValue(action.field),
                type: actionType,
                value: optionValue(action.value)
              },
          sequence_template_id: isSequenceTemplate ? optionValue(action.value) : null
        }

        ruleObj.trigger_actions.data.push(actionObj)
      }

      return ruleObj
    },
    hasValidRuleName (rule) {
      return Boolean((rule?.name || '').trim())
    },
    normalizeComparableValue (value) {
      if (Array.isArray(value)) {
        return value
          .map(item => this.normalizeComparableValue(item))
          .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right)))
      }

      if (value && typeof value === 'object') {
        const optionVal = optionValue(value)
        if (optionVal !== undefined && optionVal !== value) {
          return this.normalizeComparableValue(optionVal)
        }

        return Object.keys(value)
          .sort()
          .reduce((acc, key) => {
            acc[key] = this.normalizeComparableValue(value[key])
            return acc
          }, {})
      }

      if (typeof value === 'string') {
        return value.trim()
      }

      return value ?? null
    },
    normalizeConditionItem (condition = {}) {
      return {
        fieldType: optionValue(condition.fieldType) ?? null,
        field: optionValue(condition.field) ?? condition.field?.id ?? condition.field ?? null,
        operator: optionValue(condition.operator) ?? null,
        value: this.normalizeComparableValue(condition.value)
      }
    },
    normalizeConditionGroup (group = {}) {
      const conditions = (group.conditions || [])
        .map(condition => this.normalizeConditionItem(condition))
        .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right)))

      return {
        match: group.match || 'AND',
        joinWithNext: group.joinWithNext || 'AND',
        conditions
      }
    },
    normalizeRuleConditions (rule = {}) {
      return (rule.conditionGroups || [])
        .map(group => this.normalizeConditionGroup(group))
        .sort((left, right) => JSON.stringify(left).localeCompare(JSON.stringify(right)))
    },
    areConditionsIdentical (ruleA, ruleB) {
      return JSON.stringify(this.normalizeRuleConditions(ruleA)) === JSON.stringify(this.normalizeRuleConditions(ruleB))
    },
    normalizeRuleConfiguration (rule = {}) {
      return optionValue(rule.configuration) ?? rule.configuration?.id ?? rule.configuration ?? null
    },
    isSameConfiguration (ruleA, ruleB) {
      return this.normalizeRuleConfiguration(ruleA) === this.normalizeRuleConfiguration(ruleB)
    },
    findRuleWithIdenticalConditions (currentRule) {
      return this.materialRules.find(rule => {
        if (this.matchRuleId(rule.id, currentRule.id)) {
          return false
        }

        if (!this.isSameConfiguration(currentRule, rule)) {
          return false
        }

        return this.areConditionsIdentical(currentRule, rule)
      }) || null
    },
    hasUniqueConditions (currentRule) {
      return !this.findRuleWithIdenticalConditions(currentRule)
    },
    isRuleNameUnique (currentRule) {
      const currentName = (currentRule?.name || '').trim().toLowerCase()
      if (!currentName) {
        return true
      }

      return !this.materialRules.some(rule => {
        if (this.matchRuleId(rule.id, currentRule.id)) {
          return false
        }

        return (rule?.name || '').trim().toLowerCase() === currentName
      })
    },
    ensureValidRuleName (rule) {
      if (!this.hasValidRuleName(rule)) {
        window.alert('Rule name is required.')
        if (rule?.id) {
          this.$set(this.ruleValidationMap, rule.id, {
            ...(this.ruleValidationMap[rule.id] || {}),
            nameRequired: true,
            duplicateName: false,
            message: 'Rule name is required.'
          })
        }
        return false
      }

      if (this.isRuleNameUnique(rule)) {
        return true
      }

      if (rule?.id) {
        this.$set(this.ruleValidationMap, rule.id, {
          ...(this.ruleValidationMap[rule.id] || {}),
          nameRequired: false,
          duplicateName: true,
          message: 'Rule name must be unique.'
        })
      }
      return false
    },
    async handleEditSave (rule) {
      if (this.disable || this.isSavingRules || !rule) {
        return
      }

      this.isSavingRules = true
      const loader = new Loader()
      try {
        this.showValidationErrors = true
        const validation = this.validateRule(rule)
        if (!validation.isValid) {
          this.$set(this.ruleValidationMap, rule.id, validation.validationState)
          return
        }
        if (!this.ensureValidRuleName(rule)) {
          return
        }
        this.clearRuleValidation(rule.id)

        const hasValidStandardMaterialFields = await this.validateStandardMaterialFormFieldsBeforeSave()
        if (!hasValidStandardMaterialFields) {
          return
        }

        // const hasValidStandardMaterialFields = await this.validateStandardMaterialFormFieldsBeforeSave()
        // if (!hasValidStandardMaterialFields) {
        //   return
        // }'
        if (!this.checkCircularDependencies()) {
          const fieldLabels = this.circularDependencyResult.conflictingFields
            .map(f => formatDependencyFieldKey(f))
            .join(', ')
          const isSelfReference = this.circularDependencyResult.cycleEdges
            .some(edge => this.matchRuleId(edge.from, edge.to))
          const reason = isSelfReference
            ? 'A rule cannot use a field in its conditions and set the same field in its actions'
            : 'Circular dependency detected'
          notifyAlert(`${reason}: ${fieldLabels}. Please resolve the conflict before saving.`)
          return
        }

        this.disable = true
        loader.show()

        if (!rule.isDraft) {
          const deleteResponse = await deleteConfigurationRuleApi({ validationIds: [rule.id] })
          const affectedRows = deleteResponse?.delete_validations?.affected_rows ??
            deleteResponse?.data?.delete_validations?.affected_rows

          if (affectedRows !== 1) {
            notifyAlert('Someone has already edited/deleted this Rule. Please refresh.')
            return
          }
        }

        await createConfigurationRuleApi({ input: [this.buildRuleInput(rule)] })
        await this.loadRulesData()
        this.clearRuleValidation(rule.id)
        this.editingRuleId = null
        this.editingRuleSnapshot = null
        this.setRuleEditingState()
        success('Rule saved successfully')
      } catch (err) {
        console.log(err)
      } finally {
        loader.hide()
        this.disable = false
        this.isSavingRules = false
      }
    },
    async saveRules () {
      if (this.disable || this.isSavingRules) {
        return
      }
      this.isSavingRules = true
      const loader = new Loader()
      try {
        this.showValidationErrors = true
        if (!this.syncRuleValidation(true)) {
          return
        }
        const invalidRule = this.materialRules.find(rule => !this.hasValidRuleName(rule))
        if (invalidRule) {
          this.ensureValidRuleName(invalidRule)
          return
        }
        this.disable = true
        loader.show()
        const rulesToSave = [...this.materialRules]
        const validationIds = [...this.existingRuleIds]
        const input = rulesToSave.map(rule => this.buildRuleInput(rule))

        if (validationIds.length) {
          await deleteConfigurationRuleApi({ validationIds })
        }
        await createConfigurationRuleApi({ input })
        await this.loadRulesData()
        success('rules saved successfully')
      } catch (err) {
        console.log(err)
      } finally {
        loader.hide()
        this.disable = false
        this.isSavingRules = false
      }
    },
    async handleRuleDelete (ruleId) {
      const rule = this.rules.find(item => this.matchRuleId(item.id, ruleId))
      if (!rule) {
        return
      }

      if (rule.isDraft) {
        this.removeRule(ruleId)
        return
      }

      this.isSavingRules = true
      const loader = new Loader()
      try {
        this.disable = true
        loader.show()

        const deleteResponse = await deleteConfigurationRuleApi({ validationIds: [ruleId] })
        const affectedRows = deleteResponse?.delete_validations?.affected_rows ??
          deleteResponse?.data?.delete_validations?.affected_rows

        if (affectedRows !== 1) {
          notifyAlert('Someone has already edited/deleted this Rule. Please refresh.')
          return
        }

        await this.loadRulesData()
        success('Rule deleted successfully')
      } catch (err) {
        console.log(err)
      } finally {
        loader.hide()
        this.disable = false
        this.isSavingRules = false
      }
    },
    async loadRulesData () {
      this.rulesLoading = true
      try {
        const data = await getRulesApi()
        const validations = data?.validations || data?.data?.validations || []
        const rulsArray = []
        this.existingRuleIds = []
        for (const [index, rule] of validations.entries()) {
          this.existingRuleIds.push(rule.id)
          const ruleObj = {
            id: rule.id,
            name: rule.name || '',
            flag: 'existing',
            feature: 'MATERIAL',
            active: true,
            expanded: index === 0,
            configuration: CONFIGURE_TYPES.find(item => item.id === rule.target),
            conditionGroups: [],
            actions: []

          }
          for (const group of rule.validation_groups) {
            const groupObj = {
              id: group.id,
              match: group.type,
              joinWithNext: group.operator_to_next_group,
              expanded: true,
              conditions: []
            }
            for (const condition of group.validation_conditions) {
              const source = formatToDropDownInput(SOURCE_ITEMS, condition.source)
              const isPluginCustomField = optionValue(source) === 'PLUGIN_CUSTOM_FIELDS'
              const field = isPluginCustomField
                ? condition.left_operand
                : findConditionField({
                  selectedSource: source,
                  fieldId: condition.left_operand
                }) || { id: condition.left_operand }
              const integerFallback = usesNativeIntegerIds(field)
                ? toIntegerId(condition.int_value ?? condition.string_value)
                : null
              const conditionCustomListKey = getCustomListLookupKey(field)
              const matchedCustomListIntValues = Array.isArray(condition.int_list)
                ? condition.int_list
                  .map((id) => findOptionByValue(this.$store.getters['tenantConfig/getCustomListMap']?.[conditionCustomListKey] || [], { id }) || { id })
                  .filter(Boolean)
                : []
              const matchedCustomListValue = integerFallback !== null
                ? findOptionByValue(this.$store.getters['tenantConfig/getCustomListMap']?.[conditionCustomListKey] || [], { id: integerFallback })
                : null
              const conditionObj = {
                id: createId(),
                field, // this one for id name is not available , pass like this , it will automatically select from list
                operator: formatToDropDownInput(OPERATORS, condition.operator),
                value: isIncludesOperator(formatToDropDownInput(OPERATORS, condition.operator))
                  ? (matchedCustomListIntValues.length ? matchedCustomListIntValues : getConditionStoredValue(condition))
                  : condition.bool_value ?? condition.date_value ??
                    matchedCustomListValue ??
                    (integerFallback !== null ? { id: integerFallback } : null) ?? getConditionStoredValue(condition),
                fieldType: source
              }
              groupObj.conditions.push(conditionObj)
            }

            ruleObj.conditionGroups.push(groupObj)
          }
          for (const action of rule.trigger_actions) {
            const isSequenceTemplate = isSequenceTemplateConfig(ruleObj.configuration)
            const actionType = action.trigger_action === 'UPDATE'
              ? 'SET'
              : (action.trigger_action || action.metadata?.type || 'SET')
            const mapMetadata = Array.isArray(action.metadata) ? action.metadata[0] || {} : {}
            const mapSource = formatToDropDownInput([...CONFIGURE_TYPES, ...SOURCE_ITEMS], mapMetadata.source)
            const mapTargetKey = mapMetadata.target_key || mapMetadata.target
            const actionObj = isSequenceTemplate
              ? {
                id: action.id,
                field: '',
                source: '',
                type: { id: 'SET', name: 'SET', value: 'SET' },
                value: findOptionByValue(this.dropdownLists.sequenceTemplateValues, action.sequence_template_id) ||
                    action.core_sequence_id_template ||
                    (action.sequence_template_id ? { id: action.sequence_template_id } : ''),
                metadata: action.metadata
              }
              : actionType === 'MAP'
                ? {
                  id: action.id,
                  field: this.resolveActionTargetField(ruleObj.configuration, mapTargetKey),
                  source: mapSource,
                  type: { id: 'MAP', name: 'MAP', value: 'MAP' },
                  value: this.resolveMapSourceField(
                    mapSource,
                    mapMetadata.source_key,
                    this.resolveActionTargetField(ruleObj.configuration, mapTargetKey)
                  )
                }
                : {
                  id: action.id,
                  field: this.resolveActionTargetField(ruleObj.configuration, action.metadata?.field),
                  source: '',
                  type: { id: actionType, name: actionType, value: actionType },
                  value: action.metadata?.value
                }
            ruleObj.actions.push(actionObj)
          }
          if (isSequenceTemplateConfig(ruleObj.configuration) && ruleObj.actions.length > 1) {
            ruleObj.actions = [ruleObj.actions[0]]
          }
          if (!ruleObj.actions.length) {
            ruleObj.actions.push(createAction())
          }
          rulsArray.push(ruleObj)
        }
        this.rules = rulsArray
        if (!rulsArray.length) {
          this.editingRuleId = null
          this.editingRuleSnapshot = null
        }
        this.syncRuleValidation()
        this.checkCircularDependencies()
      } catch (err) {
        console.log(err)
        this.rules = []
      } finally {
        this.rulesLoading = false
      }
    },
    hasConditionValidationErrors (ruleValidation = {}) {
      if (ruleValidation.nameRequired) {
        return false
      }
      if (ruleValidation.duplicateName) {
        return false
      }
      if (ruleValidation.duplicateConditions) {
        return false
      }
      if (ruleValidation.conditionsRequired) {
        return true
      }
      return Object.values(ruleValidation.conditions || {}).some(conditionValidation => {
        return Object.values(conditionValidation || {}).some(Boolean)
      })
    },
    hasActionValidationErrors (ruleValidation = {}) {
      if (ruleValidation.actionsRequired) {
        return true
      }
      return Object.values(ruleValidation.actions || {}).some(actionValidation => {
        return Object.values(actionValidation || {}).some(Boolean)
      })
    },
    getRuleValidationMessage (ruleValidation = {}) {
      if (ruleValidation.nameRequired) {
        return 'Rule name is required.'
      }
      if (ruleValidation.duplicateName) {
        return 'Rule name must be unique.'
      }
      if (ruleValidation.duplicateConditions) {
        return `A rule with the same configuration and identical conditions already exists (Rule: "${ruleValidation.duplicateConditionRuleName || 'Unnamed Rule'}").`
      }
      const hasConditionErrors = this.hasConditionValidationErrors(ruleValidation)
      const hasActionErrors = this.hasActionValidationErrors(ruleValidation)

      if (hasConditionErrors && hasActionErrors) {
        return 'Conditions and Actions need to be filled before saving.'
      }
      if (hasConditionErrors) {
        return 'Conditions need to be filled before saving.'
      }
      if (hasActionErrors) {
        return 'Actions need to be filled before saving.'
      }
      return ''
    },
    validateRule (rule) {
      const { isValid, ruleValidationMap } = validateConfigurationRules([rule])
      const ruleValidation = ruleValidationMap?.[rule.id] || {}
      const nameRequired = !this.hasValidRuleName(rule)
      const duplicateName = !nameRequired && !this.isRuleNameUnique(rule)
      const duplicateConditionRule = this.findRuleWithIdenticalConditions(rule)
      const validationState = {
        ...ruleValidation,
        nameRequired,
        duplicateName,
        duplicateConditions: Boolean(duplicateConditionRule),
        duplicateConditionRuleName: duplicateConditionRule?.name || ''
      }
      return {
        isValid: isValid && !nameRequired && !duplicateName && !duplicateConditionRule,
        validationState: {
          ...validationState,
          message: this.getRuleValidationMessage(validationState)
        }
      }
    },
    clearRuleValidation (ruleId) {
      if (!Object.prototype.hasOwnProperty.call(this.ruleValidationMap, ruleId)) {
        return
      }
      this.$delete(this.ruleValidationMap, ruleId)
    },
    refreshRuleValidationState (ruleId, ruleOverride = null) {
      if (!Object.prototype.hasOwnProperty.call(this.ruleValidationMap, ruleId)) {
        return
      }

      const rule = ruleOverride || this.rules.find(item => this.matchRuleId(item.id, ruleId))
      if (!rule) {
        this.clearRuleValidation(ruleId)
        return
      }

      const validation = this.validateRule(rule)
      if (validation.isValid) {
        this.clearRuleValidation(ruleId)
        return
      }

      this.$set(this.ruleValidationMap, ruleId, {
        ...validation.validationState,
        message: ''
      })
    }
  }
}
</script>

  <style scoped>
  .component-cards {
    margin-top: 30px;
    width: 100%;
  }

  .material-rules-actions {
    display: flex;
    justify-content: flex-end;
    padding: 0 30px 22px;
  }

  .component-card {
    display: table;
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #ccc;
    table-layout: fixed;
    margin-top: 20px;
  }

  .component-row {
    display: table-row;
  }

  .tabs {
  border: 1px solid #ccc;
  border-radius: 6px;
  overflow: hidden;
  font-family: sans-serif;
}

.tab-headers {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  background-color: #ffffff;
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
}

.tab-header {
  padding: 12px 80px;
  cursor: pointer;
  /* flex: 1; */
  text-align: center;
  transition: background 0.3s;
}

.tab-header:hover {
  background-color: #e0e0e0;
}

.tab-header.active {
  background-color: #f1f3f5;
  font-weight: 500;
  border-bottom: 2px solid var(--brand-color);
}

  .col {
    display: table-cell;
    padding: 8px 8px 8px 8px;
    border: 1px solid #ccc;
    vertical-align: middle;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .sequence--container{
    padding: 20px;
    max-width: 700px;
    overflow-y: visible;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
    margin-top: 10px;
    border-radius: 6px;
    background: white;
}
.loading-container{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 200px;
    padding: 24px;
    border: 1px solid #ccc;
    border-top: 0;
    background: #ffffff;
    box-sizing: border-box;
  }
  </style>
